// 🔧 index.js
// ✅ Purpose: Entry point for the Volunteer Engine
// ✅ Features:
// - Exposes runVolunteerEngine()
// - Keeps Volunteer Engine imports clean for pipeline steps
// - Runs Volunteer Builder as part of the Core Demo Package
// - Returns standardized Demo Report v2-compatible results
// - Fully block-commented for clarity and future devs

import { buildVolunteers } from "./volunteer_builder";

export const runVolunteerEngine = async ({
  demoContext,
} = {}) => {
  console.log("🙋 Volunteer Engine started.");

  const result = await buildVolunteers({
    demoContext,
  });

  console.log("✅ Volunteer Engine completed.", {
    result,
  });

  return result;
};